<span class="relative flex flex-col w-full h-full">
    <div class="p-8 pb-6" mat-dialog-content>
        <ng-container>
            <form [formGroup]="form" #profileInNgForm="ngForm" (keyup.enter)="save()">
                <div class="sm:flex xs:block w-100 border-b pb-[10px]">
                    <!-- Avatar and actions -->
                    <div class="sm:flex-initial xs:block xs:max-w-100 sm:max-w-30pr items-center max-w-[200px]"></div>

                    <div class="sm:flex-initial xs:block w-full min-w-0">
                        <!-- Header -->
                        <div class="flex items-start justify-between gap-3 pb-3">
                            <div class="min-w-0 flex-1">
                                <div
                                    class="font-bold pt-1 leading-tight text-xl sm:text-3xl md:text-4xl line-clamp-2"
                                    [matTooltip]="user?.name"
                                >
                                    {{ user?.name }}
                                </div>

                                @if (user?.kennitala) {
                                <div class="text-xl sm:text-2xl truncate">{{ 'kt. ' + formatKennitala(user?.kennitala) }}</div>
                                }
                            </div>

                            <button type="button" (click)="dialogCloseMessage()" mat-icon-button class="shrink-0 self-start">
                                <mat-icon class="text-secondary" [svgIcon]="'heroicons_outline:x'"></mat-icon>
                            </button>
                        </div>

                        @if (!data.user.isEmployee) {
                        <div class="flex items-center justify-between">
                            <div class="flex-auto cursor-pointer min-w-0">
                                <div class="leading-6 font-medium">{{ 'label_external_employee' | translate }}</div>
                            </div>
                            <mat-slide-toggle class="ml-2 shrink-0" [color]="'primary'" formControlName="externalEmployee">
                            </mat-slide-toggle>
                        </div>
                        }
                    </div>
                </div>
                <div class="float-left w-[100%] mt-4">
                    <div class="space-y-4">
                        @if (user?.jobTitle) {
                        <div class="flex sm:items-center">
                            <mat-icon [svgIcon]="'heroicons_outline:office-building'"></mat-icon>
                            <div class="ml-6 leading-6">{{user?.jobTitle}}</div>
                        </div>
                        } @if (user?.officeLocation) {
                        <div class="flex sm:items-center">
                            <mat-icon [svgIcon]="'mat_outline:business'"></mat-icon>
                            <div class="ml-6 leading-6">{{user?.officeLocation}}</div>
                        </div>
                        } @if (user?.department) {
                        <div class="flex sm:items-center">
                            <mat-icon [svgIcon]="'mat_outline:festival'"></mat-icon>
                            <div class="ml-6 leading-6">{{user?.department}}</div>
                        </div>
                        } @if (user?.email != null && user?.email.length > 0) {
                        <div class="flex">
                            <mat-icon [svgIcon]="'heroicons_outline:mail'"></mat-icon>
                            <div class="min-w-0 ml-6 space-y-1">
                                <div class="flex items-center leading-6">
                                    <a class="c-link" [href]="'mailto:' + user?.email" target="_blank"> {{user?.email}} </a>
                                </div>
                            </div>
                        </div>
                        }
                        <!-- Phone -->
                        @if (user?.mobilePhone?.length) {
                        <div class="flex">
                            <mat-icon [svgIcon]="'heroicons_outline:phone'"></mat-icon>
                            <div class="min-w-0 ml-6 space-y-1">
                                <div class="flex items-center leading-6">
                                    <div class="font-mono">{{user?.mobilePhone}}</div>
                                </div>
                            </div>
                        </div>
                        }
                        <!-- Birthday -->
                        @if (birthday) {
                        <div class="flex sm:items-center">
                            <mat-icon [svgIcon]="'heroicons_outline:cake'"></mat-icon>
                            <div class="ml-6 leading-6">{{birthday | date:'dd.MM.yyyy'}}</div>
                        </div>
                        }
                    </div>
                </div>
                @if (data.user.isEmployee || this.form.get('externalEmployee').value) {
                <div class="float-left w-full mt-5 mb-2">
                    <div class="ml-0.5 font-medium text-secondary pb-[10px] border-b">{{ 'label_access_role' | translatePlural }}</div>
                    <div class="grid place-items-center pt-4">
                        @if (user?.userId && loading) {
                        <mat-progress-spinner [diameter]="32" [mode]="'indeterminate'"></mat-progress-spinner>
                        }
                    </div>
                    @if (!loading && user?.userId) {
                    <div class="float-left w-100 pt-[10px] mb-none">
                        <div class="space-y-2">
                            <mat-accordion class="mat-accordion">
                                @for (group of data.roleGroups; track group; let isFirst = $first) {
                                <mat-expansion-panel class="mat-expansion-adgangur" [expanded]="isFirst">
                                    <mat-expansion-panel-header>
                                        <mat-panel-title> {{ 'label_role_group_' + group.roleGroupName | transloco }} </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <div class="grid grid-cols-4 gap-2 w-full mt-1">
                                        @for (role of rolesGroupMap[group.roleGroupId]; track role) {
                                        <div class="col-span-4">
                                            <div class="flex items-center justify-between">
                                                <div class="flex-auto cursor-pointer">
                                                    <div class="leading-6 font-medium">{{ 'label_role_' + role.roleName | transloco }}</div>
                                                    <div class="text-md text-secondary">{{ 'info_role_' + role.roleName | transloco }}</div>
                                                </div>
                                                <mat-slide-toggle class="ml-2" [color]="'primary'" [formControlName]="role.roleName">
                                                </mat-slide-toggle>
                                            </div>
                                            <!-- Selection list for editing config contexts -->
                                            <div class="flex items-center justify-between">
                                                <div class="flex-auto cursor-pointer">
                                                    @if (role.roleName == 'edit_configs' && this.form.get(role.roleName).value) {
                                                    <div>
                                                        <mat-selection-list
                                                            class="ml-2"
                                                            [color]="'primary'"
                                                            formControlName="configContexts"
                                                        >
                                                            @for (context of data.configContexts; track context) {
                                                            <mat-list-option [value]="context.contextName">
                                                                <div class="text-md text-secondary">
                                                                    {{ 'label_context_' + context.contextName | transloco }}
                                                                </div>
                                                            </mat-list-option>
                                                            }
                                                        </mat-selection-list>
                                                    </div>
                                                    }
                                                </div>
                                            </div>
                                            <!-- Selection list for editing translation contexts -->
                                            <div class="flex items-center justify-between">
                                                <div class="flex-auto cursor-pointer">
                                                    @if (role.roleName == 'edit_translations' && this.form.get(role.roleName).value) {
                                                    <div>
                                                        <mat-selection-list
                                                            class="ml-2"
                                                            [color]="'primary'"
                                                            formControlName="translationContexts"
                                                        >
                                                            @for (context of data.translationContexts; track context) {
                                                            <mat-list-option [value]="context.contextName">
                                                                <div class="text-md text-secondary">
                                                                    {{ 'label_translation_contexts_' + context.contextName | transloco }}
                                                                </div>
                                                            </mat-list-option>
                                                            }
                                                        </mat-selection-list>
                                                    </div>
                                                    }
                                                </div>
                                            </div>
                                            <!-- Selection list for editing logsExternalSystems -->
                                            <div class="flex items-center justify-between">
                                                <div class="flex-auto cursor-pointer">
                                                    @if (role.roleName == 'external_system_logs' && this.form.get(role.roleName).value) {
                                                    <div>
                                                        <mat-selection-list
                                                            class="ml-2"
                                                            [color]="'primary'"
                                                            formControlName="logExternalSystems"
                                                        >
                                                            @for (system of data.externalSystems; track system) {
                                                            <mat-list-option [value]="system.systemName">
                                                                <div class="text-md text-secondary">
                                                                    {{ system.divisionName + ' | ' + system.systemName}}
                                                                </div>
                                                            </mat-list-option>
                                                            }
                                                        </mat-selection-list>
                                                    </div>
                                                    }
                                                </div>
                                            </div>
                                            <!-- Selection list for editing powerBI reports -->
                                            <div class="flex items-center justify-between">
                                                <div class="flex-auto cursor-pointer">
                                                    @if (role.roleName == 'reports' && this.form.get(role.roleName).value) {
                                                    <div>
                                                        <mat-selection-list
                                                            class="ml-2"
                                                            [color]="'primary'"
                                                            formControlName="selectedReports"
                                                        >
                                                            @for (report of data.availablePowerBIReports; track report) {
                                                            <mat-list-option [value]="report.reportKey">
                                                                <div class="text-md text-secondary">
                                                                    {{ 'label_report_' + report.reportKey | transloco }}
                                                                </div>
                                                            </mat-list-option>
                                                            }
                                                        </mat-selection-list>
                                                    </div>
                                                    }
                                                </div>
                                            </div>
                                            <!-- Selection list for editing document templates -->
                                            <div class="flex items-center justify-between">
                                                <div class="flex-auto cursor-pointer">
                                                    @if (role.roleName == 'document_templates' && this.form.get(role.roleName).value) {
                                                    <div>
                                                        <mat-selection-list
                                                            class="ml-2"
                                                            [color]="'primary'"
                                                            formControlName="documentTemplateIds"
                                                        >
                                                            @for (template of data.documentTemplates; track template) {
                                                            <mat-list-option [value]="template.documentTemplateId">
                                                                <div class="text-md text-secondary">
                                                                    {{ template.templateTranslationKey | transloco }}
                                                                </div>
                                                            </mat-list-option>
                                                            }
                                                        </mat-selection-list>
                                                    </div>
                                                    }
                                                </div>
                                            </div>
                                            <!-- Selection list for editing document division permissions -->
                                            <div class="flex items-center justify-between">
                                                <div class="flex-auto cursor-pointer">
                                                    @if (role.roleName == 'document_access_files_with_division' &&
                                                    this.form.get(role.roleName).value) {
                                                    <div>
                                                        <table mat-table [dataSource]="documentDivisionTableSource" class="w-full">
                                                            <ng-container matColumnDef="divisionName">
                                                                <th mat-header-cell *matHeaderCellDef>Svið</th>
                                                                <td mat-cell *matCellDef="let element" [formGroup]="element">
                                                                    {{ element.get('name').value }}
                                                                </td>
                                                            </ng-container>
                                                            <ng-container matColumnDef="canListDocuments">
                                                                <th mat-header-cell class="text-center" *matHeaderCellDef>Lista</th>
                                                                <td
                                                                    mat-cell
                                                                    class="text-center"
                                                                    *matCellDef="let element"
                                                                    [formGroup]="element"
                                                                >
                                                                    <mat-checkbox formControlName="canListDocuments"></mat-checkbox>
                                                                </td>
                                                            </ng-container>
                                                            <ng-container matColumnDef="canReadDocuments">
                                                                <th mat-header-cell class="text-center" *matHeaderCellDef>Sækja</th>
                                                                <td
                                                                    mat-cell
                                                                    class="text-center"
                                                                    *matCellDef="let element"
                                                                    [formGroup]="element"
                                                                >
                                                                    <mat-checkbox formControlName="canReadDocuments"></mat-checkbox>
                                                                </td>
                                                            </ng-container>
                                                            <tr mat-header-row *matHeaderRowDef="documentDivisionsColumns"></tr>
                                                            <tr mat-row *matRowDef="let row; columns: documentDivisionsColumns;"></tr>
                                                        </table>
                                                    </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        }
                                    </div>
                                </mat-expansion-panel>
                                }
                            </mat-accordion>
                        </div>
                    </div>
                    } @if (!user?.userId) {
                    <div class="flex flex-col items-center">
                        <span>{{ 'info_unregistered_employee_access_roles' | translate }}</span>
                    </div>
                    }
                </div>
                }
            </form>
            <div class="float-left w-100 pb-4 sm:pb-2 text-right">
                <div class="flex items-center justify-end">
                    @if (form.dirty) {
                    <button mat-stroked-button type="button" (click)="revertAllChanges()" [disabled]="!formEnabled">
                        {{ 'label_cancel' | translate }}
                    </button>
                    } @if (user?.userId) {
                    <button class="ml-4" (click)="save()" mat-flat-button type="submit" [color]="'primary'" [disabled]="!formEnabled">
                        @if (formEnabled) {
                        <span> {{ 'label_save' | translate }} </span>
                        } @if (!formEnabled) {
                        <mat-progress-spinner [diameter]="24" [mode]="'indeterminate'"> </mat-progress-spinner>
                        }
                    </button>
                    } @if (!user?.userId) {
                    <button class="w-32" mat-flat-button [color]="'primary'" (click)="registerUser()" [disabled]="loading">
                        @if (!loading) {
                        <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                        } @if (!loading) {
                        <span class="ml-2 mr-1 hidden md:block">{{ 'label_register' | translate }}</span>
                        } @if (loading) {
                        <mat-progress-spinner [diameter]="24" [mode]="'indeterminate'"> </mat-progress-spinner>
                        }
                    </button>
                    }
                </div>
            </div>
        </ng-container>
    </div>
</span>
